import { _axios } from '@/plugins/axios';

const dicomResource = '/api/v1/dicom';

export default {
  studies: payload => _axios.post(`${dicomResource}/studies`, payload),
  studyInformation: (dicomStudyId, payload) =>
    _axios.post(`${dicomResource}/studies/${dicomStudyId}`, payload),
  simplifiedTags: (dicomInstanceId, payload) =>
    _axios.post(`${dicomResource}/instance/${dicomInstanceId}/simplified-tags`, payload),
  onboardStudy: (dicomStudyId, payload) =>
    _axios.post(`${dicomResource}/onboard/${dicomStudyId}`, payload),
  healthcheck: payload => _axios.post(`${dicomResource}/healthcheck/`, payload),
};
